export function MediamarktPrivacyNL() {
  return (
    <article>
      <h1>Privacybeleid</h1>
      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <p>
          Dit Privacybeleid is van toepassing op alle producten, diensten en
          websites die door Jottacloud worden aangeboden. Verwijzingen naar
          "wij", "onze" en "ons" verwijzen naar Jottacloud, terwijl "u" en "uw"
          verwijzen naar de klant of gebruiker van Jottacloud.
        </p>
        <h3>Informatie die wij verzamelen</h3>
        <p>
          Wanneer u de diensten en websites van Jottacloud bezoekt, verstrekt u
          ons twee soorten informatie: Persoonlijke gegevens die u er bewust
          voor kiest om openbaar te maken die door ons worden verzameld, en de
          website gebruikt informatie die door ons wordt verzameld terwijl u met
          onze diensten omgaat.
        </p>
        <h3>Informatie die u verstrekt</h3>
        <p>
          Wanneer u zich bij Jottacloud registreert, geeft u ons uw naam, uw
          e-mailadres en telefoonnummer, hierna persoonsgegevens genoemd.
        </p>
        <p>
          Wachtwoorden worden gecodeerd in onze databases. Wij kunnen uw
          wachtwoord niet lezen. Jottacloud heeft geen toegang tot uw
          creditcardgegevens.
        </p>
        <p>
          Als u een geregistreerde gebruiker van Jottacloud bent, erkent u en
          stemt u ermee in dat Jottacloud u af en toe belangrijke communicatie
          over uw account of de Dienst kan sturen via e-mail of SMS.
        </p>
        <h3>Informatie over het gebruik van de website</h3>
        <p>
          Wanneer u Jottacloud gebruikt, verzamelen wij uw browsertype en
          IP-adres. Deze informatie wordt verzameld voor alle Jottacloud
          bezoekers en gebruikers. Daarnaast slaan we bepaalde informatie van uw
          browser op met behulp van "cookies". Een cookie is een stukje
          informatie dat op de computer van de gebruiker wordt opgeslagen en
          gekoppeld is aan informatie over de gebruiker. Wij gebruiken
          sessie-ID-cookies om te bevestigen dat geregistreerde gebruikers zijn
          ingelogd.
        </p>
        <p>
          We gebruiken permanente cookies om informatie over het gebruik van de
          website op te slaan. Permanente cookies worden voor een langere
          periode op uw computer opgeslagen. Dergelijke informatie is niet
          persoonlijk identificeerbaar.
        </p>
        <h3>Gegevens uploaden</h3>
        <p>
          Wanneer u bestanden uploadt op Jottacloud, stuurt u ook informatie
          over het bestandssysteem, inclusief namen van bestanden en mappen.
          Bestanden worden gecodeerd met Secure Socket Layer (SSL) tijdens de
          overdracht.
        </p>
        <h3>Hoe we de informatie gebruiken</h3>
        <ul>
          <li>
            We gebruiken de informatie die we verzamelen om de gebruikers
            hoogwaardige diensten te leveren en om nieuwe producten en diensten
            te ontwikkelen voor onze klanten en potentiële klanten.
          </li>
          <li>
            Wij kunnen de metadata van uw bestandssysteem (bestandsnaam,
            grootte, etc., maar niet de inhoud van uw bestand) bekijken om
            technische ondersteuning te bieden.
          </li>
          <li>
            Wij zullen uw e-mailadres niet verkopen of op de markt brengen.
          </li>
          <li>Wij zullen uw Persoonsgegevens niet aan derden verstrekken.</li>
          <li>
            Wij zullen de bestanden die u uploadt naar Jottacloud niet bekijken.
          </li>
        </ul>
        <h3>Kinderen onder de 13 jaar</h3>
        <p>
          Kinderen onder de 13 jaar mogen zich niet inschrijven bij Jottacloud.
          Jottacloud verzamelt of vraagt niet bewust om persoonsgegevens van
          personen jonger dan 13 jaar en staat dergelijke personen niet bewust
          toe zich te registreren.
        </p>
        <h3>Veiligheid</h3>
        <p>
          Wij maken gebruik van standaard beveiligingsmaatregelen om ons te
          beschermen tegen verlies, misbruik en wijziging van de informatie
          onder onze controle.
        </p>
        <p>
          Omdat e-mail en instant messaging niet worden herkend als beveiligde
          communicatie, verzoeken wij u ons geen gevoelige Persoonsgegevens per
          e-mail of instant messaging services te sturen.
        </p>
        <p>
          Als u uw account annuleert, kunnen uw gegevens en andere informatie
          worden bewaard in ons archief of back-upbestand tot ze na 90 dagen
          worden verwijderd.
        </p>
        <h3>Links</h3>
        <p>
          Jottacloud kan links naar andere websites bevatten. Wij zijn niet
          verantwoordelijk voor het privacybeleid van andere websites. Dit
          privacybeleid is uitsluitend van toepassing op informatie die door
          Jottacloud wordt verzameld.
        </p>
        <h3>Toegang, Aanpassen en Verwijderen van Persoonlijke Gegegevens</h3>
        <p>
          U hebt het recht om inzage, correctie of verwijdering te eisen van de
          Persoonsgegevens die wij verwerken. U hebt ook het recht om een
          beperkte behandeling, bezwaar tegen de behandeling en het recht op
          gegevensportabiliteit te eisen. U kunt uw toestemming voor de
          verwerking van Persoonsgegevens te allen tijde intrekken.
        </p>
        <h3>Klachten</h3>
        <p>
          Als u van mening bent dat onze verwerking van Persoonsgegevens niet
          overeenkomt met wat we hier beschreven hebben of als we anderszins de
          privacywetgeving schenden, kunt u een beroep doen op de
          Gegevensbeschermingsautoriteit (GBA):
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>
        <h3>Wijzigingen in dit beleid</h3>
        <p>
          Jottacloud behoudt zich het recht voor om dit beleid te allen tijde
          naar eigen goeddunken te herzien, aan te passen of te wijzigen.
          Kennisgevingen van herzieningen, wijzigingen of aanpassingen van dit
          beleid zullen op de websites van Jottacloud worden geplaatst en het
          voortgezette gebruik van de Dienst door een Gebruiker betekent dat
          hij/zij akkoord gaat met dergelijke wijzigingen. Kennisgevingen van
          bovengenoemde wijzigingen zullen per e-mail aan de gebruiker worden
          verzonden.
        </p>
      </div>
    </article>
  )
}
